
const state = {
    presupuestoInternoId: 0,
    presupuestando: false,
};

const mutations = {
    'INICIALIZAR_PRESUPUESTACION'(state, presupuestoInternoId) {
        state.presupuestando = true;
        state.presupuestoInternoId = presupuestoInternoId;
    },
    'FINALIZAR_PRESUPUESTACION'(state) {
        state.presupuestando = false;
        state.presupuestoInternoId = 0;
    },
};

const getters = {
    presupuestando (state) {
        return state.presupuestando;
    },
    presupuestoInternoId (state) {
        return state.presupuestoInternoId;
    },
};

const actions = {
    InicializarPresupuestacion ( { commit }, presupuestoInternoId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_PRESUPUESTACION', presupuestoInternoId);
            resolve();
        }, error => {
            reject(error);
        })            
    },
    FinalizarPresupuestacion ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('FINALIZAR_PRESUPUESTACION');
            resolve();
        }, error => {
            reject(error);
        })            
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}